import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddFreeVideoLayer = () => {
  const [formValues, setFormValues] = useState({
    title: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [freeVideo, setFreeVideo] = useState(null);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreviewUrl, setThumbnailPreviewUrl] = useState("");

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions
    
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const formData = new FormData();
      formData.append("title", formValues.title);

      if (freeVideo) formData.append("video_url", freeVideo);
      if (thumbnail) formData.append("thumbnail", thumbnail);
      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-freevideo`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/freevideo-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setFreeVideo(file);
    if (file) {
      const url = URL.createObjectURL(file);
      setVideoPreviewUrl(url);
    }
  };
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnail(file);
    if (file) {
      const url = URL.createObjectURL(file);
      setThumbnailPreviewUrl(url);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>

              <div className="mb-20">
                <label
                  htmlFor="freeVideo"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Free Video<span className="text-danger-600">*</span>
                </label>
                <div className="upload-field">
                  {/* Hidden file input */}
                  <input
                    type="file"
                    id="freeVideo"
                    accept="video/*"
                    onChange={handleVideoChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("freeVideo").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Video
                    </button>


                    {/* {videoPreviewUrl && (
                      <button
                        type="button"
                        onClick={() => {
                          setVideoPreviewUrl(null);
                          // Reset the file input
                          document.getElementById("courseVideo").value = "";
                        }}
                        className="btn btn-outline-danger"
                      >
                        <i className="fas fa-trash me-2"></i>
                        Remove Video
                      </button>
                    )} */}
                  </div>
                  {videoPreviewUrl && (
                    <div className="mt-2">
                      <video
                        controls
                        className="w-100"
                        style={{ maxHeight: "200px" }}
                        src={videoPreviewUrl}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="thumbnail"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Thumbnail Image<span className="text-danger-600">*</span>
                </label>
                <div className="upload-field">
                  {/* Hidden file input */}
                  <input
                    type="file"
                    id="thumbnail"
                    accept="image/*"
                    onChange={handleThumbnailChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("thumbnail").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Image
                    </button>

                  </div>
                  {thumbnailPreviewUrl && (
                    <div className="mt-2">
                      <img
                        className="w-100"
                        style={{ maxHeight: "200px" }}
                        src={thumbnailPreviewUrl}
                        alt="Thumbnail Preview"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* 
              <div className="mb-20">
                {/* <label
                      htmlFor="title"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Free Video
                      <span className="text-danger-600">*</span>
                    </label> */}
              {/* <div className="mb-20">
                  <label
                    htmlFor="freeVideo"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                  >
                    Free Video <span className="text-danger-600">*</span>
                  </label>
                  <div className="upload-field">
                    <input
                      type="file"
                      id="freeVideo"
                      accept="video/*"
                      onChange={handleVideoChange}
                      className="form-control radius-8"
                      required
                    />
                    {videoPreviewUrl && (
                      <div className="mt-2">
                        <video
                          controls
                          className="w-100"
                          style={{ maxHeight: "200px" }}
                          src={videoPreviewUrl}
                        >
                          {/* <source
                              src={videoPreviewUrl}
                              type={freeVideo?.type}
                            /> */}
              {/* Your browser does not support the video tag. */}
              {/* </video> */}
              {/* </div> */}
              {/* )} */}
              {/* </div> */}
              {/* </div> */}
              {/* </div> */}
              <div className="mb-20">
                <label
                  htmlFor="title"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Title
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="title"
                  required
                  placeholder="Enter Title"
                  value={formValues.title}
                  onChange={(e) => {
                    
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        title: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/freevideo-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                // onClick={handleFormSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
        // variant="filled"
        // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddFreeVideoLayer;
